import { singletonHook } from 'react-singleton-hook';
import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type InvoiceArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectInvoiceArtifactsData: (
    invoiceId: string,
    initialAttachmentsIds: string[],
  ) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const initState: InvoiceArtifactsInfoReceiver = {
  hookLoading: true,
  collectInvoiceArtifactsData: async () => ({}),
};

const useInvoiceArtifactsInfoReceiverImpl = () => {
  const { getInvoiceArtifactsInfo } = useArtifactInfoService();

  const collectInvoiceArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo: getInvoiceArtifactsInfo,
    getBatchIds: (invoiceId: string, initialAttachmentsIds: string[]) =>
      filterValidArtifactIds(initialAttachmentsIds).length ? [invoiceId] : [],
  });

  return {
    hookLoading: false,
    collectInvoiceArtifactsData,
  };
};

const useInvoiceArtifactsInfoReceiver = singletonHook(initState, useInvoiceArtifactsInfoReceiverImpl);

export default useInvoiceArtifactsInfoReceiver;
